import { createContext } from "react";
import { iGlobalModalsProps } from "../components/GlobalModals";

export const GlobalModalContext = createContext((props: iGlobalModalsProps) => {});
export const ConfirmContext = createContext(false);
